import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./AdminEditarDevolucion.css";
  const API = process.env.REACT_APP_API_URL

export default function AdminEditarDevolucion() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [devolucion, setDevolucion] = useState(null);
  const [estado, setEstado] = useState("");
  const [cargando, setCargando] = useState(true);

  const getToken = () => localStorage.getItem("token");

  useEffect(() => {
    cargarDevolucion();
  }, [id]);


  
  const renovarToken = async () => {
    console.log("Intentando renovar sesión...");
    try {
      const res = await fetch( API + "/user/refresh",{
        method:"POST",
         credentials: "include"
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem("token", data.accessToken);

        return true;
      }
    } catch (error) {
      console.error("Error crítico al renovar token:", error);
    }
    return false;
  };

  const cargarDevolucion = async () => {
    try {
      const res = await fetch(
        `${API}/devolucion/traerDevolucionPedidos/${id}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (res.status === 403){
       const renovado = await renovarToken();
      if (renovado) await cargarDevolucion();
      return;

      }
      const data = await res.json();
      setDevolucion(data.datos);
      setEstado(data.datos.estado);
    } catch (error) {
      console.error("Error cargando devolución", error);
    } finally {
      setCargando(false);
    }
  };


  const solicitarReembolso = async () => {
    try {
      const res = await fetch(
        `${API}/api/pagos/reembolso/${id}`,
        {
          method:"POST",
          headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "application/json",
          },
        }
      );


      if (res.status === 403){
       const renovado = await renovarToken();
      if (renovado) await solicitarReembolso();
      return;

      }

      
      const data = await res.json();
      
      console.log(data.respuesta)
      
    } catch (error) {
      console.error("Error cargando devolución", error);
    } finally {
      setCargando(false);
    }
  };

  const actualizarEstado = async () => {
  if (!estado) return;
  setCargando(true); // Bloquea UI mientras procesa
  try {
    // 1. Actualizar el estado de la devolución en tu tabla de devoluciones
    let response = await fetch(
      `${API}/devolucion/actualizarEstadoDevolucion/${devolucion.id}/${estado}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 403) {
      const renovado = await renovarToken();
      if (renovado) await actualizarEstado();
      return;
    }

    if (response.ok) {
      
      if (estado === "REEMBOLSADO") {
        console.log("Iniciando trámite de dinero con Wompi...");
        await solicitarReembolso();
      }
      
      alert("✅ Gestión actualizada correctamente");
      cargarDevolucion();
    }
  } catch (error) {
    alert("❌ Error al procesar la solicitud");
  } finally {
    setCargando(false);
  }
  }


  if (cargando) return <div className="loader">Cargando devolución...</div>;
  if (!devolucion) return <p>No se encontró la devolución.</p>;

  return (
    <main className="admin-container">
      <header className="admin-header">
        <button className="btn-back" onClick={() => navigate(-1)}>← Volver</button>
        <h2>Gestión de Devolución #{id}</h2>
      </header>

      <div className="grid-layout">
        {/* Columna Izquierda: Información */}
        <section className="info-card">
          <h3>📋 Detalles de la Solicitud</h3>
          <div className="details-list">
            <div className="detail-item">
              <label>ID Pedido</label>
              <p>{devolucion.pedidoId}</p>
            </div>
            <div className="detail-item">
              <label>Cliente</label>
              <p>{devolucion.userDTO.nombre}</p>
            </div>
            <div className="detail-item">
              <label>Fecha Solicitud</label>
              <p>{new Date(devolucion.fechaSolicitud).toLocaleDateString()}</p>
            </div>
            <div className="detail-item full-width">
              <label>Motivo</label>
              <p className="highlight-text">{devolucion.motivo}</p>
            </div>
            <div className="detail-item full-width">
              <label>Comentario del Cliente</label>
              <p className="comment-box">{devolucion.comentario || "Sin comentarios adicionales"}</p>
            </div>
          </div>
        </section>

        {/* Columna Derecha: Acción y Multimedia */}
        <aside className="action-card">
          <div className="status-selector">
            <label>Cambiar Estado</label>
            <select 
              value={estado} 
              onChange={(e) => setEstado(e.target.value)}
              className={`select-status ${estado.toLowerCase()}`}
            >
              <option value="SOLICITADA">⏳SOLICITADA</option>
              <option value="APROBADA">✅ Aprobada</option>
              <option value="PRODUCTO_RECIBIDO">📦 Producto recibido</option>
              <option value="RECHAZADA">❌ Rechazada</option>
              <option value="REEMBOLSADO">💰 Reembolsado</option>
            </select>
            <button className="btn-save" onClick={actualizarEstado}>
              Guardar Cambios
            </button>
          </div>

          <div className="evidence-section">
            <h3>📷 Evidencia Visual</h3>
            <div className="image-grid">
              {devolucion.urlsImagenes?.length > 0 ? (
                devolucion.urlsImagenes.map((url, index) => (
                  <div key={index} className="img-wrapper">
                    <img
                      src={`${API}${url}`}
                      alt="Evidencia"
                      onClick={() => window.open(`${API}${url}`, "_blank")}
                    />
                  </div>
                ))
              ) : (
                <p className="empty-msg">No se adjuntaron fotos</p>
              )}
            </div>
          </div>
        </aside>
      </div>
    </main>
  );
}